<template>
  <div :class="{ 'has-logo': showLogo }" class="sidebar-container">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="getMenuBackground"
        :text-color="getMenuTextColor" :unique-opened="true" :active-text-color="theme" :collapse-transition="false"
        mode="vertical" :class="sideTheme" style="padding-bottom: 80px;">
        <sidebar-item v-for="(route, index) in sidebarRouters" :key="route.path + index" :item="route"
          :base-path="route.path" />
      </el-menu>
      <!-- <span class="appVersion" v-if="!isCollapse" style="
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        font-size: 14px;
        transform: translate(-50%);
        ">{{ version }}</span> -->
    </el-scrollbar>
  </div>
</template>
<script setup>
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/assets/styles/variables.module.scss'
import useAppStore from '@/store/modules/app'
import useSettingsStore from '@/store/modules/settings'
import usePermissionStore from '@/store/modules/permission'
//import { computed, useRoute } from 'vue';
const version = import.meta.env.VITE_APP_VERSION;
const route = useRoute();
const appStore = useAppStore()
const settingsStore = useSettingsStore()
const permissionStore = usePermissionStore()

const sidebarRouters = computed(() => permissionStore.sidebarRouters);
const showLogo = computed(() => settingsStore.sidebarLogo);
const sideTheme = computed(() => settingsStore.sideTheme);
const theme = computed(() => settingsStore.theme);
const isCollapse = computed(() => !appStore.sidebar.opened);

// 获取菜单背景颜色
const getMenuBackground = computed(() => {
  if (settingsStore.isDark) {
    return 'var(--sidebar-bg)';
  }
  switch (sideTheme.value) {
    case 'theme-dark':
      return variables.menuBg;
    case 'theme-light':
      return variables.menuLightBg;
    case 'theme-blue':
      return variables.menuBlueBg; // 假设 variables 中有 menuBlueBg 变量
    case 'theme-atropurpureus':
      return variables.menuAtropurpureusBg;
    default:
      return variables.menuBg;
  }
});

// 获取菜单文字颜色
const getMenuTextColor = computed(() => {
  if (settingsStore.isDark) {
    return 'var(--sidebar-text)';
  }
  switch (sideTheme.value) {
    case 'theme-dark':
      return variables.menuText;
    case 'theme-light':
      return variables.menuLightText;
    case 'theme-blue':
      return variables.menuBlueText; // 假设 variables 中有 menuBlueText 变量
    case 'theme-atropurpureus':
      return variables.menuAtropurpureusText;
    default:
      return variables.menuText;
  }
});

const activeMenu = computed(() => {
  const { meta, path } = route;
  if (meta.activeMenu) {
    return meta.activeMenu;
  }
  return path;
});
</script>

<style lang="scss" scoped>
//@import '@/assets/styles/variables.module.scss';

.sidebar-container {
  background-color: v-bind(getMenuBackground);

  .scrollbar-wrapper {
    background-color: v-bind(getMenuBackground);
  }

  .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;

    .el-menu-item,
    .el-sub-menu__title {
      &:hover {
        background-color: var(--menu-hover, rgba(0, 0, 0, 0.06)) !important;
      }
    }

    .el-menu-item {
      color: v-bind(getMenuTextColor);

      &.is-active {
        color: var(--menu-active-text, #409eff);
        background-color: var(--menu-hover, rgba(0, 0, 0, 0.06)) !important;
      }
    }

    .el-sub-menu__title {
      color: v-bind(getMenuTextColor);
    }
  }
}
</style>
